<template>
  <div class="comp-fh-from-table-title">
    <template v-if="colItem.colKey != 'operation'">
      <jw-space size="mini">
        <component :is="componentFun(fieldItem?.setting?.fieldType == 21 ? fieldItem?.setting?.business : fieldItem?.setting)" />
        <span>{{ fieldItem?.setting?.fieldName }}</span>
        <qf-icon-required v-if="colItem?.isRequired || fieldItem?.isRequired" />
      </jw-space>
    </template>
    <template v-else>
      <div class="title-text">操作</div>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import useObjectForm from '@/hooks/object-form';
const { componentFun } = useObjectForm();
const props = defineProps({
  col: {
    type: Object,
    default: () => {}
  },
  fieldItem: {
    type: Object,
    default: () => {}
  }
});

const colItem = computed(() => {
  return props.col;
});

const fieldItem = computed(() => {
  return props.fieldItem;
});
</script>
<style scoped lang="less">
@import './fh-from-table-title.less';
</style>
